import { Component, Inject, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';

@Component({
    selector: 'cmps-client-logo',
    template: ` <img
            [src]="url"
            alt
            role="presentation"
            onerror="this.onerror = null; this.style.display = 'none';"
            [ngClass]="{
                'jumbotron-client-logo': !login,
                'login-client-logo left': login
            }"
        />
        <img
            class="login-client-logo right"
            [src]="urlRight"
            alt
            role="presentation"
            onerror="this.onerror = null; this.style.display = 'none';"
            *ngIf="login"
        />`,
})
export class ClientLogoComponent implements OnInit {
    @Input()
    login: boolean;

    @Input()
    fallBackToOrbitLogo: boolean = false;

    url: SafeResourceUrl;
    urlRight: SafeResourceUrl;

    constructor(
        private readonly _domSanitizer: DomSanitizer,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    ngOnInit(): void {
        if (this._appConfig.CLIENT_LOGO) {
            this.url = this._domSanitizer.bypassSecurityTrustResourceUrl(
                this._appConfig.CLIENT_LOGO,
            );
        }
        if (this.fallBackToOrbitLogo && !this.url) {
            this.url = this._domSanitizer.bypassSecurityTrustResourceUrl(
                'assets/orbit-group-logo-icon.svg',
            );
        }

        if (this._appConfig.CLIENT_LOGO_RIGHT) {
            this.urlRight = this._domSanitizer.bypassSecurityTrustResourceUrl(
                this._appConfig.CLIENT_LOGO_RIGHT,
            );
        }
    }
}
